
export default function Security() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Cumplimiento GDPR',
      description: 'Protección de datos personales según normativa europea. Servidores en la UE.'
    },
    {
      icon: 'ri-user-settings-line',
      title: 'Roles y permisos',
      description: 'Control granular: cada usuario ve y hace solo lo que necesita según su rol.'
    },
    {
      icon: 'ri-brain-line',
      title: 'IA como apoyo',
      description: 'La IA sugiere y prioriza. El equipo clínico siempre valida y decide.'
    }
  ];

  return (
    <section className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-[#0A1628] mb-4 sm:mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
            Seguridad y Transparencia
          </h2>
          <p className="text-base sm:text-xl text-gray-600 max-w-3xl mx-auto px-2">
            PreBedAI está diseñado para el entorno sanitario, con seguridad, trazabilidad y respeto al criterio clínico.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-8 mb-8 sm:mb-12">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-lg sm:rounded-xl p-4 sm:p-6 hover:bg-gray-100 transition-colors"
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#6D28D9] rounded-lg flex items-center justify-center mb-3 sm:mb-4">
                <i className={`${feature.icon} text-xl sm:text-2xl text-white`}></i>
              </div>
              
              <h3 className="text-base sm:text-lg font-bold text-[#0A1628] mb-1.5 sm:mb-2">
                {feature.title}
              </h3>
              
              <p className="text-sm text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Important Note */}
        <div className="bg-gradient-to-r from-[#6D28D9]/10 to-[#06B6D4]/10 border-l-4 border-[#6D28D9] p-4 sm:p-8 rounded-lg max-w-4xl mx-auto">
          <div className="flex items-start gap-3 sm:gap-4">
            <i className="ri-information-line text-[#6D28D9] text-2xl sm:text-3xl flex-shrink-0 mt-0.5"></i>
            <div>
              <h4 className="text-lg sm:text-xl font-bold text-[#0A1628] mb-2 sm:mb-3">
                La IA no decide, apoya
              </h4>
              <p className="text-gray-700 leading-relaxed text-sm sm:text-base mb-2 sm:mb-3">
                PreBedAI utiliza inteligencia artificial para analizar datos históricos y sugerir prioridades, pero <strong>nunca sustituye el criterio clínico</strong>. Cada predicción y cada decisión pasa por la validación del equipo profesional.
              </p>
              <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                La base de conocimiento médico es editable por el hospital, y todas las sugerencias de la IA son transparentes y trazables.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
